import { render, staticRenderFns } from "./SttDictionaryEdit.vue?vue&type=template&id=7b52528d&scoped=true"
import script from "./SttDictionaryEdit.vue?vue&type=script&lang=js"
export * from "./SttDictionaryEdit.vue?vue&type=script&lang=js"
import style0 from "./SttDictionaryEdit.vue?vue&type=style&index=0&id=7b52528d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b52528d",
  null
  
)

export default component.exports